// extracted by extract-css-chunks-webpack-plugin
module.exports = {"toc-wide-variant":"_3q3sBS","bottom":"_2r08Kt","hideDesktop":"_2iz79J","hideNotDesktop":"_3CQc5J","stickyBox":"_2NfjGw"};